import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";

import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import Popup02 from "../../pages/popup/Popup02"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import PopupProfileEdit from "../../pages/popup/PopupProfileEdit"
import PopupRegisterCoupon from "../../pages/popup/PopupRegisterCoupon"

import MyCard from "../../components/MyCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import PaginationPayList from '../../components/PaginationPayList';

export default function CardList() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const fileRef = useRef();
    const popRef = useRef(null);

    const [cardList, setCardList] = useState([]);
    const [mainCard, setMainCard] = useState({});

    const [otherPop, setOtherPop] = useState(false);
    const [paypopflag, setpaypopflag] = useState(false);
    const [intervals, setintervals] = useState(false);

    const PAYSTATION_ORIGINS = [
		"https://secure.xsolla.com",
		"https://sandbox-secure.xsolla.com"
	];
	let savedAccountAdded = false;

    useEffect(() => {
        window.scrollTo(0, 0);

        if(!mbData?.idx) {
            navigate(routes.main);
        } 
        cardData();
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const cardData = async() => {
        const result = await API.xsollaApis("user/XsolaApiCardlist", {idx: mbData?.idx});
        //setMainCard(result?.result);
        setMainCard(result?.result);
        //console.log(result?.result);
    }

    const handleOutsideClick = (event) => {
        if (popRef.current && !popRef.current.contains(event.target)) {
            setOtherPop(false);
        }
    };

    const plusCardFunc = async() => {
        setpaypopflag(true);
        const result = await API.xsollaApis("user/XsolaApiTokens", { idx: mbData?.idx });
        console.log("result : ", result?.tokens);
        const iframe = document.getElementById("paystation-frame");
        const container = document.getElementById("paystation-container");

        iframe.src = `https://secure.xsolla.com/paystation4/?token=${result?.tokens}`;
        container.style.display = "block";
        setintervals(setInterval(async() => {
            const ckresult = await API.xsollaApis("user/XsolaAddchecking", { idx: mbData?.idx });
            //console.log(ckresult?.result);
            if(ckresult?.status === 200){
                setintervals((val) => {
                    clearInterval(val);
                });
                handleSavedAccountAdded(ckresult?.result);
            }
            if(ckresult?.status === 400){
                dispatch(open({
                    component:
                        <Popup01
                            max_width={'300px'}
                            x_btn={false}
                            text1={result?.message}
                            longButton={lang === 0 ? '확인' : 'OK'}
                        />
                }));   
                payclose();
                setintervals((val) => {
                    clearInterval(val);
                });
            }

        }, 1000));

    }

    const payclose = () => {
        cardData();
        setintervals((val) => {
            clearInterval(val);
        });
        setpaypopflag(false);
    }

    const handleMessage = (event) => {
        return;
        // 모든 메시지 출력
        console.log("📨 수신된 postMessage1:", event.origin);
        console.log("📨 수신된 postMessage2:", event.data);

        // handleSavedAccountAdded({});
        // return;

        // origin 확인
        if (!PAYSTATION_ORIGINS.includes(event.origin)) return;

        let message = event.data;
        console.log(message);
        // 문자열인 경우 파싱 시도
        if (typeof message === 'string') {
            try {
                message = JSON.parse(message.replace(/'/g, '"'));
            } catch (error) {
                console.warn("⚠️ 메시지 파싱 실패:", error);
                payclose();
                return;
            }
        }

        // 이벤트별 처리
        if (message.command === 'add_saved_account') {
            savedAccountAdded = true;
            console.log("✅ add_saved_account 이벤트 수신");
            handleSavedAccountAdded(message.data);
        }

        if (message.status === 'close') {
            console.log("❌ close 이벤트 수신");
            if (!savedAccountAdded) {
                payclose();
                //alert("❌ 저장된 결제 수단 추가 실패");
            }
            document.getElementById("paystation-container").style.display = "none";
            document.getElementById("paystation-frame").src = "";
        }

        if (message.status === 'done') {
            console.log("✅ 결제 완료 이벤트 수신");
        }

        if (message.status === 'error') {
            console.error("🚨 오류 이벤트 수신:", message);
        }
    }

    const CardOffTestFunc = () => {
        dispatch(open({
            component: 
                <Popup02
                    button={lang === 0 ? '발송' : 'Send'}
                    buttonCancel={lang === 0 ? '닫기' : 'Close'}
                    cardOffTest={true}
                    setFunc={() => {
                        
                    }}
                />
        }));
    }

    const handleSavedAccountAdded = async(account) => {
        dispatch(loadingStart());
        // let sender = {
        //     idx: mbData?.idx,
        //     cardName: account.name,
        //     carduserid: account.user_id,
        // }
        //{"command":"add_saved_account","data":{"id":33135497,"name":"411111******1111","payment_method":1380,"type":"card","invoice_id":1640676986,"version":"Pay Station 4"}}
        let sender = {
            idx: mbData?.idx,
            cardName: account.name,
            carduserid: account.id, //or invoice_id
        }
        const result = await API.xsollaApis("user/XsolaCardAdd", sender);
        dispatch(loadingEnd());
        dispatch(open({
            component:
                <Popup01
                    max_width={'300px'}
                    x_btn={false}
                    text1={
                        result?.message === '결제 수단이 저장되었습니다.' ? lang === 0 ? result?.message : 'Your payment method has been saved.' :
                            result?.message === '이미 등록된 카드가 있습니다.' ? lang === 0 ? result?.message : 'A card has already been registered.' : ''
                    }
                    longButton={lang === 0 ? '확인' : 'OK'}
                />
        }));   
        // document.getElementById("paystation-container").style.display = "none";
        // document.getElementById("paystation-frame").src = "";
        if(result?.status === 200){
            payclose();
        }
        //alert("✅ 결제 수단이 저장되었습니다!");
        // console.log("💾 저장된 카드 정보:", account);
        // if (account && account.name) {
        //     console.log(`💳 카드 이름: ${account.name}`);
        // }
    }

    const DeleteCard = () => {
        dispatch(open({
            component: 
                <Popup01 
                    max_width={'300px'}
                    text1={lang === 0 ? '등록된 카드를 삭제하시겠습니까?' : 'Do you want to delete the registered card?'}
                    button={lang === 0 ? '삭제하기' : 'Delete'}
                    buttonCancel={lang === 0 ? '닫기' : 'Close'}
                    setFunc={() => {
                        dispatch(loadingStart());
                        setTimeout(async() => {
                            let sender = {
                                idx: mbData?.idx,
                            }
                            const result = await API.xsollaApis("user/XsolaCardDelete", sender);
                            dispatch(loadingEnd());
                            dispatch(open({
                                component:
                                    <Popup01
                                        max_width={'300px'}
                                        x_btn={false}
                                        text1={result?.message === "삭제되었습니다." ? 
                                            lang === 0 ? '삭제되었습니다.' : 'Deleted.'
                                        :result?.message}
                                        longButton={lang === 0 ? '확인' : 'OK'}
                                    />
                            }));   
                            if(result?.status === 200){
                                cardData();
                                payclose();
                            }
                        }, 500);
                    }}
                />
        }));
    }

    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box" style={{ marginBottom: 100 }}>
                        <div 
                            className="title_box"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default}/>
                            <p>{lang === 0 ? '카드 관리' : 'Card Management'}</p>
                        </div>

                        <div className="profile_edit coupon card">
                            <div className="coupon_title_box card_title_box">
                                <p>{lang === 0 ? '카드 관리' : 'Card Management'}</p>
                                <span>
                                    {lang === 0 
                                        ? '카드를 교체하시려면 기존 카드를 삭제한 후 새 카드를 등록해 주세요.'
                                        : 'Please delete your existing card before registering a new one.'}
                                </span>
                                {/* <button 
                                    type="button"
                                    className="test_btn"
                                    onClick={() => {
                                        CardOffTestFunc()
                                    }}
                                >
                                    카드 사용불가 이메일 테스트 버튼
                                </button> */}
                            </div>
                            {mainCard?.idx && 
                            <MyCard mainCard={mainCard} DeleteCard={DeleteCard} />
                            }
                            {!mainCard?.idx &&
                            <div 
                                className="plus_card_btn"
                                onClick={() => {
                                    plusCardFunc();
                                    //handleSavedAccountAdded();
                                }}
                            >
                                <img src={require("../../assets/icon/add-line-blue.svg").default}/>
                                <p>{lang === 0 ? '카드 등록' : 'Register Card'}</p>
                                {/* <span>(최대 3개)</span> */}
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
            {paypopflag === true &&
            <div 
                style={{
                    position: 'fixed', left: 0, top: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}
            >
                <button
                    className='payclose'
                    onClick={() => {
                        payclose();
                    }}
                >
                    <img src={require("../../assets/icon/x.svg").default}  />
                </button>
                <div id="paystation-container" >
                    <iframe id="paystation-frame" style={{ width: '100%', height: '100%' }}></iframe>
                </div>
            </div>}
        </>
    );
}